__turbopack_context__.v({
  "campaign": "CardCampaign-module-scss-module__Q90toq__campaign",
  "description": "CardCampaign-module-scss-module__Q90toq__description",
  "fade-in": "CardCampaign-module-scss-module__Q90toq__fade-in",
  "headline": "CardCampaign-module-scss-module__Q90toq__headline",
  "iconWrapper": "CardCampaign-module-scss-module__Q90toq__iconWrapper",
  "image": "CardCampaign-module-scss-module__Q90toq__image",
  "imageContainer": "CardCampaign-module-scss-module__Q90toq__imageContainer",
});
